module.exports = __webpack_public_path__ + "start-right.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/start-right.png
// module id = 303
// module chunks = 0